import { makeFilterParams } from '../../utils/helpers/helpers';
import httpClient from '../httpClient';

const projectSelector = async () => {
  return await httpClient.get('/announcement_project_selector');
};

const organizationSelector = async () => {
  return await httpClient.get('/announcement_organization_selector');
};

const post = async (data) => {
  return await httpClient.post(`/announcement/`, data);
};

const postDocument = async (data) => {
  return await httpClient.post(`/announcement/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const getAll = async () => {
  return await httpClient.get(`/announcement/`);
};

const get = async (id) => {
  return await httpClient.get(`/announcement/${id}/`);
};

const put = async (id, data) => {
  return await httpClient.put(`/announcement/${id}/`, data);
};

const putDocument = async (id, data) => {
  return await httpClient.put(`/announcement/${id}/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const postTemplateDocument = async (id, data) => {
  return await httpClient.post(`/announcement/${id}/template/`, data, {
    headers: {
      'Content-Type': `multipart/form-data;`,
    },
  });
};

const ajaxTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );

  return await httpClient.get(
    exportCSV ? '/announcement/export' : '/announcement',
    params,
  );
};

const filter = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = 'id',
  search = '',
) => {
  return await httpClient.get(
    `/announcement` +
      `${query}&page[number]=${page}&page[size]=${pageSize}` +
      `&sort=${sortBy}` +
      `&filter[search]=${search}`,
  );
};

const getErrorsFile = async (id) => {
  return await httpClient.post(`/announcement/${id}/download_errors/`, null, {
    responseType: 'blob',
  });
};

const finishedAjaxTable = async (
  query = {},
  page = 1,
  pageSize = 10,
  sortBy = '-created_at',
  search = false,
  exportCSV = false,
) => {
  const params = makeFilterParams(
    query,
    page,
    pageSize,
    search,
    sortBy,
    exportCSV,
  );

  return await httpClient.get(
    exportCSV ? '/announcement_finished/export' : '/announcement_finished',
    params,
  );
};

const postFile = async (data) => {
  return await httpClient.post(`/announcement_invite/upload_file/`, data);
};

const deleteFile = async (id) => {
  return await httpClient.delete(`/announcement_invite/${id}/delete_file/`);
};

const assignFile = async (id) => {
  return await httpClient.patch(`/announcement_invite/${id}/assign_file/`);
};

const filesTable = async (
  query = '',
  page = 1,
  pageSize = 10,
  sortBy = '',
  search = false,
  _exportCSV = false,
) => {
  let searchBy = '';

  if (search) searchBy = '&filter[search]=' + search;
  if (sortBy) sortBy = '&sort=' + sortBy;

  return await httpClient.get(
    `/announcement_invite/list_files/?filter[convocatoria]=${query}&page[number]=${page}&page[size]=${pageSize}${sortBy}${searchBy}`,
  );
};

const downloadFile = async (id) => {
  return await httpClient.get(`/announcement_invite/${id}/download_errors/`, {
    responseType: 'blob',
  });
};

const generatePublicLink = async (id) => {
  return await httpClient.patch(`/announcement/${id}/make_public_link/`);
};

const launch = async (id) => {
  return await httpClient.post(`/announcement/${id}/launch/`);
};

const invitationsTable = async (
  query,
  page = 1,
  pageSize = 10,
  _sortBy = 'created_at',
  search = false,
  _exportCSV = false,
) =>
  await httpClient.get(
    'announcement_invite/',
    makeFilterParams({ convocatoria: query }, page, pageSize, search),
  );

const removeInvitation = async (id) => {
  return await httpClient.delete(`announcement_invite/${id}`);
};

const terminateAnnouncement = async (id) =>
  await httpClient.patch(`/announcement/${id}/terminate/`, {});

export {
  projectSelector,
  organizationSelector,
  post,
  postDocument,
  getAll,
  get,
  put,
  putDocument,
  postTemplateDocument,
  filter,
  getErrorsFile,
  ajaxTable,
  finishedAjaxTable,
  postFile,
  deleteFile,
  assignFile,
  filesTable,
  downloadFile,
  invitationsTable,
  removeInvitation,
  generatePublicLink,
  launch,
  terminateAnnouncement,
};
